import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let state = {
    loading: 0,
    screenWidth: null,
    bodyHeight: null,
    user: null,
    errors: [],
    messages: [],
    warnings: [],
    webp: '',
    icons: {},
    active: {},
    pageData: null,
    captchas: {},
    notFound: false,
    seo: {},
    serverFetched: false,
    mobile: false,
    updateBodyHeight(){
        //const head = document.querySelector('.main-header');
        const foot = document.querySelector('.main-footer');
        if(/*head && */foot){
            /*const headerTop = parseInt(window.getComputedStyle(head).getPropertyValue('margin-top').match(/\d+/)[0]);
            const headerBottom = parseInt(window.getComputedStyle(head).getPropertyValue('margin-bottom').match(/\d+/)[0]);*/
            const footerTop = parseInt(window.getComputedStyle(foot).getPropertyValue('margin-top').match(/\d+/)[0]);
            const footerBottom = parseInt(window.getComputedStyle(foot).getPropertyValue('margin-bottom').match(/\d+/)[0]);
            this.bodyHeight = window.innerHeight - 6 /*- head.getBoundingClientRect().height*/ - foot.getBoundingClientRect().height /*- headerTop - headerBottom*/ - footerTop - footerBottom;
        }
    }
};

export default function createStore() {
    return new Vuex.Store({
        state: () => state
    })
};